import React from "react";

import { Box, Text, VStack } from "@chakra-ui/react";

import { SymptomDisplay } from "./SymptomDisplay";

interface SymptomsBoxProps {
  symptoms: string[];
}

export const SymptomsBox: React.FC<SymptomsBoxProps> = ({ symptoms }) => {
  return (
    <Box borderWidth="1px" borderColor="brand.dark_green" borderRadius="lg" p={4}>
      <Text textStyle="sectionTitle">Symptoms</Text>
      <VStack align="stretch" spacing={2}>
        {symptoms.map((symptom, index) => (
          <SymptomDisplay key={index} symptom={symptom} />
        ))}
      </VStack>
    </Box>
  );
};
